<template>
    <section id="acomodacoes">
    <div class="center-container">
      <div class="title">
        <h2>Acomodações</h2>
        <h3>Chalés, Trailer, Cozinha equipada</h3>
        <div class="decoration">
          <div class="dotted-border"></div>
          <i class="fab fa-pagelines"></i>
          <div class="dotted-border"></div>
        </div>
      </div>
      <div class="content">
        <p>
            A <em>Pousada Recanto da Família</em> dispõe de <strong>um chalé duplo</strong>, com dois quartos, sala, mini-cozinha e banheiro, que acomoda sete pessoas. <strong>Dois chalés com quarto e sala</strong>, que acomoda quatro pessoas. E <strong>três apartamentos suítes</strong>, que acomodam de duas a três pessoas. Os chalés e apartamentos são equipados com <em>frigobar</em>, <em>ventilador de teto</em> e <em>televisão</em>. Os hóspedes contam, ainda, com uma <span class="decorated-text">cozinha de apoio totalmente equipada</span> e uma churrasqueira.
        </p>

        <div class="gallery">
          <!-- lightbox containers hidden with CSS -->
          <div class="lightbox animate" id="accomodations1">
            <LightboxClose />
            <LightboxPrev previous="#accomodations3" />
            <LightboxNext next="#accomodations2" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac1.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations2">
            <LightboxClose />
            <LightboxPrev previous="#accomodations1" />
            <LightboxNext next="#accomodations3" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac2.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations3">
            <LightboxClose />
            <LightboxPrev previous="#accomodations2" />
            <LightboxNext next="#accomodations4" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac3.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations4">
            <LightboxClose />
            <LightboxPrev previous="#accomodations3" />
            <LightboxNext next="#accomodations5" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac4.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations5">
            <LightboxClose />
            <LightboxPrev previous="#accomodations4" />
            <LightboxNext next="#accomodations6" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac5.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations6">
            <LightboxClose />
            <LightboxPrev previous="#accomodations5" />
            <LightboxNext next="#accomodations7" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac6.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations7">
            <LightboxClose />
            <LightboxPrev previous="#accomodations6" />
            <LightboxNext next="#accomodations8" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac7.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations8">
            <LightboxClose />
            <LightboxPrev previous="#accomodations7" />
            <LightboxNext next="#accomodations9" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac8.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations9">
            <LightboxClose />
            <LightboxPrev previous="#accomodations8" />
            <LightboxNext next="#accomodations10" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac9.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations10">
            <LightboxClose />
            <LightboxPrev previous="#accomodations9" />
            <LightboxNext next="#accomodations11" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac10.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations11">
            <LightboxClose />
            <LightboxPrev previous="#accomodations10" />
            <LightboxNext next="#accomodations12" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac11.jpg" />
          </div>

          <div class="lightbox animate" id="accomodations12">
            <LightboxClose />
            <LightboxPrev previous="#accomodations11" />
            <LightboxNext next="#accomodations1" />
            <img class="animate" src="@/assets/img/photos/accomodations/ac12.jpg" />
          </div>

          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations1"><img alt="Foto Acomodação 1" src="@/assets/img/photos/accomodations/thumb/ac1_thumb.jpg" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations2"><img alt="Foto Acomodação 2" src="@/assets/img/photos/accomodations/thumb/ac2_thumb.jpg" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations3"><img alt="Foto Acomodação 3" src="@/assets/img/photos/accomodations/thumb/ac3_thumb.jpg" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations4"><img alt="Foto Acomodação 4" src="@/assets/img/photos/accomodations/thumb/ac4_thumb.jpg" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations5"><img alt="Foto Acomodação 5" src="@/assets/img/photos/accomodations/thumb/ac5_thumb.jpg" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations6"><img alt="Foto Acomodação 6" v-lazy="require('@/assets/img/photos/accomodations/thumb/ac6_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations7"><img alt="Foto Acomodação 7" v-lazy="require('@/assets/img/photos/accomodations/thumb/ac7_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations8"><img alt="Foto Acomodação 8" v-lazy="require('@/assets/img/photos/accomodations/thumb/ac8_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations9"><img alt="Foto Acomodação 9" v-lazy="require('@/assets/img/photos/accomodations/thumb/ac9_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations10"><img alt="Foto Acomodação 10" v-lazy="require('@/assets/img/photos/accomodations/thumb/ac10_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations11"><img alt="Foto Acomodação 11" v-lazy="require('@/assets/img/photos/accomodations/ac11_thumb.jpg')" /></a>
          </div>
          <div class="gallery-item">
            <a class="thumbnail" href="#accomodations12"><img alt="Foto Acomodação 12" v-lazy="require('@/assets/img/photos/accomodations/ac12_thumb.jpg')" /></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LightboxPrev from '@/components/LightboxPrev'
import LightboxNext from '@/components/LightboxNext'
import LightboxClose from '@/components/LightboxClose'

export default {
  name: 'Accomodations',
  components: {
    LightboxPrev,
    LightboxNext,
    LightboxClose
  }
}
</script>
